import React from 'react';

const TermsAndConditions = () => {
  return (
    <div
      className="terms-container"
      style={{
        padding: '20px',
        maxWidth: '100%',
        margin: '0 auto',
        lineHeight: '1.6',
        direction: 'rtl',
        textAlign: 'right',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        backgroundColor: '#fff',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          color: '#EE2C46',
          marginBottom: '20px',
          fontSize: '2rem',
        }}
      >
        תנאי שימוש למערכת
      </h1>

      <div className="terms-content">
        <p style={{ fontWeight: 'bold', textAlign: 'center' }}>(ראו מדיניות פרטיות בהמשך הדף)</p>

        <p>
          תנאים אלו (להלן "התנאים") מסדירים את מערכת היחסים, הזכויות והחובות הקיימים בינך, משתמש
          פרטי, לרבות שדכן ו\או רווק (כהגדרתם בתנאים אלו) ובין חברת מאצ׳אפליי בע״מ ח.פ. 516186699
          (להלן "החברה"), בעלת מלוא הזכויות במערכת Matchers הכוללת את אפליקציית Matchers
          ("האפליקציה") וכן כל ממשק אינטרנטי הקשור בה (כולם ביחד יקראו להלן בתנאים אלו "המערכת"),
          בכל הנוגע להורדה, להתקנה ולשימוש שתבצע במערכת ובחלקיה.
        </p>

        <p>
          כל שימוש במערכת או בחלקיה, לרבות כל גרסה מעודכנת, שינוי, שיפור, עדכון ו/או שדרוג של
          המערכת, אשר יסופקו על ידי החברה, הינו כפוף, ויהיה כפוף, לתנאים אלו בכל עת.
        </p>

        <p>
          על ידי לחיצה על לחצן "אני מאשר" ו/או בעצם השימוש במערכת ו/או על ידי הורדת והתקנת האפליקציה
          על המכשיר הנייד שלך, ורישום למערכת, אתה מסכים לתנאים אלו במלואם ומאשר כי קראת והבנת אותם
          וכי אתה מסכים שתנאים אלו יחייבו אותך, ולפיכך הינך מתבקש לקוראם בעיון רב בטרם ביצוע האמור
          לעיל, ולנהוג על פי הכתוב בהם.
        </p>

        <p>
          אם אינך מסכים למלוא תנאים אלו, או אם אינך מעוניין שתנאים אלו יחייבו אותך, אנא לחץ על כפתור
          "אני לא מאשר" ואל תתקין את האפליקציה, או אם התקנת אותה, אזי מחק אותה באופן מיידי מהמכשיר
          הנייד שלך ואל תשתמש בה בכל צורה ואופן.
        </p>

        <p>
          החברה שומרת על זכותה להכניס שינויים בתנאים אלו, על פי שיקול דעתה הבלעדי. המשך שימושך
          במערכת לאחר פרסום התנאים המעודכנים, מהווה את הסכמתך לכל שינוי כאמור.
        </p>

        <p>כל האמור בלשון זכר בהסכם זה, נעשה מטעמי נוחות ומתייחס גם אל הנקבה.</p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>השימוש במערכת</h3>
        <p>
          המערכת הינה אפליקציית היכרויות המקשרת בין שדכנים. בכל מקרה שבו תסבור המערכת כי ישנה התאמה
          בין שני רווקים, אזי תפנה המערכת לשדכנים עם פרטי הרווקים, ואלו ידרשו להחליט אם לשתף את
          ההצעה עם הרווקים שהם מייצגים. במידה ושדכן שיתף את ההצעה עם הרווק שהוא מייצג, יידרש , הרווק
          לאשר את ההצעה. רק לאחר קבלת אישור משני הרווקים, יתבצע קישור ביניהם, אשר יכלול בין היתר
          החלפת מספרי טלפון - לטובת יצירת קשר זה עם זה.
        </p>

        <p>שדכן הינו משתמש אשר הוריד את האפליקציה ונרשם למערכת כדי לשדך רווקים.</p>
        <p>רווק הינו משתמש אשר קיבל פנייה משדכן המעוניין לשדך אותו באמצעות המערכת.</p>

        <p>
          עם הורדת האפליקציה על ידי שדכן, והתקנתה במכשיר הנייד שלו, ידרש השדכן לבצע רישום ולמסור
          פרטים אודותיו, ואודות רווק אחד או יותר אשר הינו מעוניין לשדך. כל הפרטים אשר ימסרו באמצעות
          המערכת על ידי השדכן אודותיו ועבור הרווק יהיו מלאים מדויקים ועדכניים וכל טעות או אי דיוק
          שתיפול בהם הינה באחריותו של השדכן.
        </p>

        <p>
          לאחר ביצוע רישום של רווק על ידי שדכן באמצעות המערכת בהצלחה, הודעה על הרישום האמור תישלח
          לרווק לאישורו, בצירוף לינק לממשק אינטרנטי שבו יידרש הרווק להשלים פרטים נוספים. שדכן לא
          יוכל לשדך רווק שלא אישר לו זאת.
        </p>

        <p>באם הנך רווק הנך מאשר לשדכן להכניס פרטים אודותיך למערכת.</p>
        <p>לרווק תהא האפשרות להיות רשום אצל מספר שדכנים שונים.</p>

        <p>
          באמצעות האפליקציה יוכל כל שדכן לבצע, בין היתר, את הפעולות הבאות: הוספת רווקים שהוא מעוניין
          לשדך, עריכת מידע על אודות הרווקים, ניהול שיחת צ׳אט עם שדכן אחר שהמערכת חיברה אליו לצורך
          שידוך, העברת הצעות לרווקים שהוא מייצג, וכדו׳
        </p>

        <p>
          באמצעות ממשק אינטרנטי יוכל כל רווק לבצע את הפעולות הבאות, בין היתר: לאשר לשדכן לשדך אותו,
          להוסיף על עצמו פרטים אישיים, לבחון הצעות שהוא מקבל, לאשר או לדחות הצעות, להשהות את הפרופיל
          שלו וכדו׳.
        </p>

        <p>
          המערכת בלבד תוכל לשלוח הודעה לשני שדכנים על חיבור פוטנציאלי בין רווקים ולבקשם לאשרו. במקרה
          כאמור יוכלו השדכנים לתקשר ביניהם באמצעות הודעות מיידיות ו\או צ'אט ו\או WhatsApp באמצעות
          האתר ולהחליף מידע. השדכנים יכולים, לשיקול דעתם הבלעדי, להעביר את ההצעה לשידוך אל הרווקים
          עצמם, והם בתורם יוכלו לבחון את הפרופיל האישי בהצעה ולסמן במערכת אם הם מעוניינים או לא.
          במידה ושני הרווקים אישרו את ההצעה – יוחלפו פרטי הקשר והם יוכלו לתקשר ביניהם. מובהר כי
          הפרטים הקיימים במערכת הנוגעים לרווק, לא יחשפו לכל צד שלישי עד ששדכן יחליט להעביר את ההצעה.
          מובהר עוד כי לא תהא לרווק כל טענה תביעה או דרישה כלפי השדכן בקשר עם הבחירה להעביר או שלא
          להעביר את פרטיו לשדכן אחר, ובלבד שפעל על פי האמור בתנאים אלו.
        </p>

        <p>
          השימוש הבסיסי במערכת הינו ללא דמי מנוי. בנוסף, החברה מציעה לרווקים מסלול פרימיום בתשלום
          (להלן: "מסלול פרימיום") כמפורט בסעיף 'מדיניות תשלומים, ביטולים והחזרים' להלן.
        </p>

        <p>
          התקשורת שתתבצע בין השדכנים בטרם חיבור תתבצע באמצעות הודעות מיידיות ו\או צאט אשר באמצעותם
          ניתן יהיה להעביר תמונות, סרטונים, קטעי קול ומלל בכתב הנוגעים לרווק או לשדכן. כלל האחריות
          בגין כל מידע וחומרים שיועברו באמצעות הודעות מיידיות או צ'אט, מוטל על הצד שהעביר אותו,
          ואולם, מובהר כי כל צד מתחייב כי כלל הזכויות בכל מידע וחומרים שיעביר, שייך לו, ואינו מפר
          זכויות צדדים שלישיים כלשהם.
        </p>

        <p>
          ואולם לחברה תהיה הזכות לשמור ולבצע שימוש בכל מידע וחומרים כאמור בהתאם למדיניות הפרטיות של
          החברה. אנו ממליצים לנקוט משנה זהירות בכל הנוגע להעברת מידע או חומרים באמצעות צ'אט או
          הודעות מיידיות, וכלל האחריות בגין העברת מידע כאמור תחול על הצד שהעביר מידע כאמור.
        </p>

        <p>
          באם הנך שדכן אזי הנך מתחייב כי קיבלת את אישורו של הרווק לפרסם מידע אודותיו באפליקציה לרבות
          אישור לפרסם את כלל המידע שתבחר לפרסם אודות הרווק בין אם במהלך הרישום או במסגרת הליך של
          חיבור, וכי כל טענה תביעה או דרישה שתהא לרווק אל מול שדכן, תהא ביניהם והחברה לא תהא צד להם.
          כל אחד מהצדדים ישפה ויפצה את החברה בגין כל נזק אובדן או חיוב שיגרם לה עקב על תביעה או
          דרישה שתועלה על ידי שדכן או רווק כנגד החברה בקשר עם האמור.
        </p>

        <p>
          מובהר כי האחריות בגין כל תקשורת שיבצעו רווקים או שדכנים מחוץ למערכת, הינו על אחריותם
          הבלעדית ולחברה או למי מטעמה לא תהיה כל אחריות בגין האמור.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>מדיניות תשלומים, ביטולים והחזרים</h3>

        <p>
          <strong>1. כללי</strong>
        </p>
        <p>
          א. השימוש הבסיסי במערכת עבור כלל המשתמשים (שדכנים ורווקים) הינו ללא עלות וללא דמי מנוי,
          למעט כמפורט להלן בסעיף זה בנוגע למסלול פרימיום לרווקים.
        </p>
        <p>
          ב. החברה שומרת לעצמה את הזכות לשנות את מדיניות התשלומים, הביטולים וההחזרים, לרבות תנאי
          מסלול הפרימיום ועלותו, בכל עת, על פי שיקול דעתה הבלעדי. כל שינוי יפורסם במסגרת תנאים אלו
          וייכנס לתוקף באופן מיידי עבור מצטרפים חדשים למסלול הפרימיום, ועבור מנויים קיימים תינתן
          הודעה מראש טרם כניסת השינוי לתוקף לגביהם. המשך שימוש במסלול הפרימיום לאחר עדכון התנאים או
          כניסת השינוי לתוקף (לפי המקרה) יהווה הסכמה לתנאים המעודכנים.
        </p>

        <p>
          <strong>2. מסלול פרימיום לרווקים - Pay as you Date</strong>
        </p>
        <p>
          א. <strong>הצטרפות למסלול פרימיום:</strong> החברה מציעה לרווקים המעוניינים בכך אפשרות
          להצטרף למסלול פרימיום (להלן: "מנוי פרימיום" או "המסלול"). מסלול זה מעניק קדימות בקבלת
          הצעות שידוך, כמפורט בסעיף 2.ג להלן. ההצטרפות למסלול כפופה לאישור תנאים אלו ומהווה עסקת מכר
          מרחוק מתמשכת כהגדרתה בחוק הגנת הצרכן, התשמ"א-1981 (להלן: "חוק הגנת הצרכן"). בטרם ההצטרפות,
          יוצגו בפניך עיקרי תנאי המסלול, לרבות עלותו, מנגנון החיוב, תנאי הביטול וזכויותיך. עם השלמת
          ההצטרפות, יישלח אליך אישור בדואר אלקטרוני המפרט תנאים אלו וכולל קישור למדיניות זו.
        </p>

        <p>
          ב. <strong>עלות השירות במסלול הפרימיום:</strong> העלות עבור קיום "שידוך פעיל" (כהגדרתו
          להלן) במסגרת מסלול הפרימיום הינה 29 ש"ח (עשרים ותשעה שקלים חדשים) לחודש, כולל מע"מ (להלן:
          "דמי השירות").
        </p>

        <p>
          ג. <strong>הטבת מסלול הפרימיום:</strong> רווקים במסלול פרימיום (להלן: "רווק/ה בפרימיום")
          יקבלו קדימות בקבלת הצעות שידוך במערכת בהשוואה לרווקים שאינם במסלול הפרימיום. מובהר כי אין
          בקדימות זו התחייבות לכמות הצעות מסוימת, לקצב קבלתן, להתאמה וודאית או להצלחת שידוך כלשהו.
          ההטבה הינה מתן עדיפות אלגוריתמית במערכת.
        </p>

        <p>
          ד. <strong>תחילת חיוב דמי השירות ו"שידוך פעיל":</strong>
        </p>
        <p>
          i. החיוב בגין דמי השירות יחל באופן אוטומטי עם יצירת "שידוך פעיל" עבור רווק/ה בפרימיום.
          רווק/ה בפרימיום יכול/ה להיות ב"שידוך פעיל" אחד בלבד בכל זמן נתון.
        </p>
        <p>
          ii. "שידוך פעיל" יוגדר ככזה לאחר שהמערכת שלחה הצעת שידוך לשני הרווקים המעורבים, ושני
          הרווקים אישרו במערכת את הסכמתם ונכונותם ליצירת קשר ראשוני או יציאה לדייט בעקבות ההצעה. עם
          אישור שני הצדדים, המערכת תספק להם את פרטי הקשר ההדדיים (או תאפשר יצירת קשר ראשונית דרך
          המערכת). המשתמש יקבל הודעה ברורה על כך שנוצר "שידוך פעיל" וכי החל חיוב דמי השירות.
        </p>
        <p>iii. דמי השירות בסך 29 ש"ח נגבים עבור כל חודש, וכל עוד השידוך מוגדר כפעיל.</p>

        <p>
          ה. <strong>הפסקת "שידוך פעיל" והמשך סטטוס פרימיום:</strong>
        </p>
        <p>
          i. רווק/ה בפרימיום, אשר עבורו/ה קיים "שידוך פעיל" שבגינו נגבים דמי שירות, רשאי/ת להודיע
          לחברה בכל עת כי הקשר הזוגי במסגרת אותו "שידוך פעיל" הסתיים או הופסק (להלן: "הודעת הפסקת
          קשר"). ההודעה תימסר באמצעות פנייה לכתובת הדוא"ל [yuval@matchers.ai] או באמצעות ממשק ייעודי
          במערכת, אם וכאשר יהיה קיים.
        </p>
        <p>
          ii. עם קבלת "הודעת הפסקת קשר": 1. אותו שידוך ספציפי יפסיק להיחשב כ"שידוך פעיל" באופן מיידי
          (או לכל המאוחר תוך יום עסקים אחד). 2. החיוב בגין אותו "שידוך פעיל" יחושב באופן יחסי עד
          למועד הפסקתו בפועל. אם שולמו דמי שירות מראש עבור תקופה ארוכה יותר, יוחזר למשתמש החלק היחסי
          שלא נוצל. לדוגמה, אם "שידוך פעיל" החל ב-1 לחודש, דמי השירות (29 ש"ח) חויבו, והמשתמש הודיע
          על "הפסקת קשר" שנכנסה לתוקף ב-10 לחודש, הוא יחויב רק עבור 10 ימים ויהיה זכאי להחזר יחסי
          עבור יתרת התקופה.
        </p>
        <p>
          iii. <strong>הבהרה חשובה:</strong> "הודעת הפסקת קשר" אינה מהווה ביטול של מנוי הפרימיום
          עצמו. הרווק/ה י/תישאר במסלול הפרימיום וימשיך/תמשיך ליהנות מהטבת הקדימות בקבלת הצעות שידוך
          חדשות. חיוב חדש בגין דמי שירות יופעל באופן אוטומטי עם יצירת "שידוך פעיל" חדש, כמפורט בסעיף
          2.ד לעיל.
        </p>
        <p>
          iv. לביטול מלא של מנוי הפרימיום והפסקת כל חיוב עתידי אפשרי, יש לפעול בהתאם לאמור בסעיף 2.ו
          להלן.
        </p>
        <p>
          v. עם קבלת "הודעת הפסקת קשר" מאחד הצדדים, החברה תעדכן על כך את הרווק/ה השני/ה המעורב/ת
          בשידוך, וכן את השדכנים של שני הצדדים.
        </p>

        <p>
          ו. <strong>ביטול מנוי פרימיום והחזרים</strong>
        </p>
        <p>
          i. <strong>זכותך לביטול:</strong> 1. הנך רשאי/ת לבטל את מנוי הפרימיום שלך בכל עת. 2.
          בנוסף, בהתאם לחוק הגנת הצרכן (כהגדרתו לעיל), עומדת לך הזכות לבטל את העסקה להצטרפות למסלול
          הפרימיום בתוך 14 ימים מיום ההצטרפות למסלול או מיום קבלת מסמך המפרט את עיקרי תנאי העסקה
          (כגון אישור ההצטרפות בדוא"ל), לפי המאוחר מביניהם.
        </p>
        <p>
          ii. <strong>אופן מסירת הודעת הביטול:</strong> הודעה על רצונך לבטל את מנוי הפרימיום (להלן:
          "הודעת ביטול") תימסר לחברה באמצעות פנייה לכתובת הדוא"ל [yuval@matchers.ai] או באמצעות
          קישור ייעודי ובולט לביטול מנוי הפרימיום באפליקציה (למשל, באזור "הגדרות חשבון").
        </p>
        <p>
          iii. <strong>תוצאות הביטול:</strong> עם קבלת הודעת הביטול שלך על ידי החברה: 1. הפסקת
          השירות: מנוי הפרימיום שלך יסתיים והטבת הקדימות תבוטל לאלתר (או לכל המאוחר תוך שלושה ימי
          עסקים ממועד מסירת ההודעה, או במועד מאוחר יותר אם צוין כך על ידך בהודעה). הפרופיל שלך ישוב
          למאגר הכללי של המשתמשים שאינם בתוכנית פרימיום. 2. טיפול ב"שידוך פעיל" קיים: אם בעת מסירת
          הודעת הביטול קיים "שידוך פעיל" עבורך: א. ה"שידוך הפעיל" יופסק. ב. תחויב/י בדמי שירות באופן
          יחסי, רק עבור התקופה בה ה"שידוך הפעיל" התקיים בפועל (ממועד תחילתו ועד למועד הפסקתו כתוצאה
          מהודעת הביטול). חישוב זה יתבסס על תעריף דמי השירות (29 ש"ח) לחודש. 3. החזר כספי: אם לאחר
          חישוב החיוב היחסי כאמור לעיל, יתברר כי שילמת סכום עודף (למשל, אם חויבת מראש עבור תקופה
          ארוכה יותר של "שידוך פעיל" מכפי שנוצלה בפועל עד הביטול), יוחזר לך הסכום העודף. ההחזר יבוצע
          לאמצעי התשלום באמצעותו בוצע החיוב המקורי, וזאת בתוך 14 ימים ממועד הודעת הביטול. 4. ביטול
          לפני תחילת שירות: אם הודעת הביטול (במסגרת 14 הימים או לאחריהם) נמסרה בטרם נוצר עבורך
          "שידוך פעיל" כלשהו במסגרת מנוי הפרימיום (ולכן לא חויבת בדמי שירות), הביטול יבוצע ללא חיוב
          כלשהו.
        </p>
        <p>
          iv. <strong>הבהרה לגבי דמי ביטול:</strong> בהתאם למודל החיוב של השירות, המבוסס על תשלום
          יחסי עבור "שידוך פעיל" בפועל, החברה אינה גובה דמי ביטול נוספים מעבר לחיוב היחסי עבור
          השירות שצוין (אם וככל שסופק "שידוך פעיל"). זאת, גם במקרה של ביטול בתוך 14 הימים הראשונים
          כאמור בסעיף ו.i.2.
        </p>

        <p>
          ז. <strong>אחריות המשתמש והודעות:</strong> i. באחריות הרווק/ה בפרימיום להודיע לחברה על
          "הפסקת קשר" בגין "שידוך פעיל" ספציפי, אם ברצונו/ה להפסיק את אותו שידוך ספציפית ואת החיוב
          היחסי בגינו, כמפורט בסעיף 2.ה. ii. באחריות הרווק/ה בפרימיום המעוניין/ת לבטל לחלוטין את
          מנוי הפרימיום להודיע על כך לחברה ("הודעת ביטול"), כמפורט בסעיף 2.ו. iii. אי מתן הודעות
          כאמור עלול לגרום לחיובים בהתאם לתנאי מסלול הפרימיום. החברה לא תישא באחריות לחיובים שנגרמו
          עקב אי מסירת הודעה על ידי הרווק/ה כנדרש. iv. על אף האמור, החברה עשויה, אך אינה חייבת,
          לשלוח תזכורות תקופתיות למשתמשי פרימיום, במיוחד אם לא היה להם "שידוך פעיל" (ולכן לא חויבו)
          במשך תקופה ממושכת, המזכירות להם את סטטוס הפרימיום שלהם ואת האופן בו ניתן לבטלו.
        </p>

        <p>
          ח. <strong>פניות ושירות לקוחות למנויי פרימיום:</strong> בכל שאלה, בעיה או בירור הנוגעים
          למסלול הפרימיום, לרבות דיווחים על "הפסקת קשר", בקשות לביטול מנוי הפרימיום, או בירורים
          בנוגע לחיובים והחזרים, ניתן לפנות לכתובת הדוא"ל: [yuval@matchers.ai] או באמצעות ערוצי
          התמיכה הנוספים כפי שיפורסמו על ידי החברה מעת לעת.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>הגבלות ואיסורים</h3>
        <p>
          כתנאי להורדת האפליקציה ולשימוש במערכת הנך מתחייב כי הנך מעל לגיל 18 וכי הרווק שהנך רושם
          הינו מעל לגיל 18.
        </p>
        <p>
          הנך מתחייב כי לא תעשה כל שימוש במערכת לצורך: (א) העלאת תכנים ו/או מידע שאין לך בהם בעלות
          או זכות שימוש בהם ו/או שמפרים את הדין ו/או צו שיפוטי כלשהו ו/או שעלולים להפר זכויות
          קנייניות של צד שלישי. (ב) הפרעה, שיבוש, הגבלה או מניעת שימוש במערכת. (ג) העלאת תכנים ומידע
          מסולפים, מטעים, שקריים ו\או המזיקים לחברה ו/או למנהליה ו/או לצד שלישי כלשהו. (ד) העלאת
          מידע פוגעני, מעליב, משמיץ מאיים חומר הפוגע או מפר זכויות קנייניות של אחרים, כל חומר
          פורנוגרפי או בעל אופי מיני בוטה או העלול לפגוע ברגשות הציבור ו/או כל חומר הנוגע לקטינים
          ומזהה אותם, ו/או כל חומר בלתי חוקי, או חומר המעודד ו/או תומך ו/או מסייע בביצוע מעשה המהווה
          עבירה פלילית לפי דיני מדינת ישראל ו/או כל חומר המהווה לשון הרע על אדם או פוגע בפרטיות ו/או
          כל מידע אחר בעל אופי דומה. (ה) מטרה בלתי חוקית, או מטרה הסותרת את תנאי ההתקשרות. (ו) הטרדה
          או תלונת שווא (ז) פגיעה בצד שלישי כלשהו לרבות בפרטיות או בצנעת הפרט. (ח) שימוש עסקי או
          מסחרי במערכת או בכל מידע המועבר דרכה. (ט) עשיית פעולה אשר מנוגדת לחוק. (י) פגיעה ו/או הפרה
          של זכויות חוזיות, זכויות קנייניות, זכויות יוצרים, זכויות מוסריות, זכויות מעין קנייניות,
          חובות זהירות ואמון, סודות מסחריים, סימני מסחר, פטנטים.
        </p>

        <p>
          הנך מתחייבת, שלא להשתמש במערכת ו/או לפעול במערכת בקשר עם הפעולות הבאות: מסירת סיסמאות ו/או
          פרטים אישיים ו/או אינטימיים אודות משתמשים אחרים ו/או הטרדת משתמשות אחרות, התחזות לאחרת,
          עשיית פרסום ו/או קידום מכירות מסחריים, תעמולה פוליטית ו/או קידום מתמודדים ומפלגות בבחירות,
          שימוש בשפה בוטה ו/או פוגענית, איסוף פרטים על משתמשים אחרים, העתקת פרטים ו/או מודעות מתוך
          המערכת ופרסומם או הצגתם במקום אחר לצרכים מסחריים או באופן שעלול לפגוע בעסקי החברה, הצפת
          המערכת בהודעות חוזרות, קידום תכנים מלאכותי, פרסום חומרים שקריים או מטעים, פרסום קישורים
          ו/או העלאת תכנים מיניים או פורנוגרפיים למערכת ו/או תכנים אשר יפגעו ברגשות משתמשים אחרים
          ו/או אשר צפויים להסב להם נזק.
        </p>

        <p>
          הנך מתחייב להימנע לחלוטין מכל ניסיון לאיסוף מידע על המערכת, לרבות באמצעים טכנולוגיים,
          הפעלה או סיוע לפעולת יישום מחשב או כל אמצעי אחר שמטרתם סריקת ו/או העתקת ו/או אחזור ו/או
          כריית מידע, להימנע מביצוע ו/או גרימת שינוי כלשהו במערכת, ולא להתערב בקוד המקור של המערכת.
        </p>

        <p>
          הנך מתחייב להימנע מביצוע פעולות ו/או מחדלים שיש בהם כדי להפריע לפעילות המערכת ו/או הגולשים
          בה, לרבות בדרך של שיבוש ו/או הפרעה לפעילות מחשב כדוגמת "וירוסים", "תולעים" ויישומים מזיקים
          אחרים, חדירה לחומר מחשב, עריכת ו/או החדרת תוכנה באופן שעלול לגרום נזק או שיבוש למחשב ו/או
          חומר מחשב, מחיקת חומר מחשב, הסגת גבול וכיו"ב.
        </p>

        <p>
          הנך מצהיר בזאת כי ידוע לך שהחברה רשאית לנקוט כנגד משתמש שיפר תנאים אלו בכל האמצעים העומדים
          לרשותה על פי דין, לרבות ביטול המנוי שלו ללא כל התראה וכן העברת פרטיו לצדדים שלישיים.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>מידע וחומרים</h3>
        <p>
          הנך מתחייב ביחס לכל מידע וחומרים שתמסור לחברה במסגרת המערכת, כי אין שום מגבלה חוקית ו/או
          חוזית ו/או אחרת המונעת ממך למסור מידע וחומרים כאמור, וכי מסירתם הינה מרצונך החופשי, ואינה
          מחויבת.
        </p>
        <p>
          ידוע לך שהחברה, לרבות נציגיה, עובדיה, מנהליה והפועלים מטעמה, אינם אחראים, בשום מקרה,
          לטיבם, מהימנותם, נכונותם, שלמותם, עדכניותם חוקיותם ותפקודם, של מידע וחומרים שתמסור או
          שתקבל באמצעות המערכת, וכי הם אינם אחראים לכל הסתמכות שתתבצע ביחס להם ולפיכך, מלוא האחריות
          בגין מידע וחומרים שתספק לחברה או לצד שלישי או שתקבל מהחברה או מצד שלישי יהיה באחריותך,
          ואתה פוטר בזאת במפורש את החברה, לרבות נציגיה, עובדיה, מנהליה והפועלים מטעמה, מכל אחריות
          ו/או חבות בקשר למידע וחומרים שתספק וכן ליעוץ שינתן לך בהתבסס עליהם.
        </p>
        <p>
          ידוע לך ואתה מאשר כי לחברה אין כל אחריות בכל הנוגע לתקשורת או להיכרות בין שני צדדים אשר
          הכירו באמצעות המערכת לרבות בכל הנוגע לנכונות המידע אודותיהם או למפגש ביניהם או למהות או
          לאופן ההתקשרות ביניהם, וכי כל אלו הינם באחריותם בלבד.
        </p>
        <p>
          החברה אינה מתחייבת לבדוק ו/או לבקר ו/או לפקח על תוכן הגולשים שתמסור או תקבל באמצעות המערכת
          והנך פוטר בזאת את החברה באופן מלא ומוחלט, לרבות בעלי מניותיה ו/או מנהליה מכל אחריות לנזק
          שיגרם או העלול להיגרם בקשר עם מסירה או קבלה או שימוש במידע וחומרים כאמור על ידי החברה.
          החברה רשאית, על פי שיקול דעתה הבלעדי, לסרב לקבל ו/או למחוק ו/או לערוך שינויים באופן מלא או
          חלקי, במידע וחומרים שתעביר לה או תקבל ממנה, ללא צורך בהסכמתך וללא מתן הודעה מוקדמת, וזאת,
          בין היתר, עקב פגיעה ו/או חשש לפגיעה בהוראות תנאים אלו, הוראות הדין או בזכויות צדדים
          שלישיים ו/או עקב הוראה של רשויות מוסמכות ו/או מטעמים טכניים.
        </p>
        <p>
          ידוע לך ואתה מאשר כי כל מידע וחומרים שימסר על ידיך לחברה יהיה בכל עת בבעלותך הבלעדית,
          ואולם, בעצם העלאת מידע וחומרים על ידיך למערכת, הנך מקנה לחברה, באופן בלתי חוזר וללא תמורה,
          רישיון לשמור כל או חלק ממידע זה במחשביה ולבצע בו שימוש, בהתאם ובכפוף לדין החל ולהוראות
          הסכם זה כדלהלן: (א) לצרכים סטטיסטיים ניתוחים ועיבודים הנוגעים לכלל משתמשי המערכת, (ב) בכדי
          לעניין אותך במוצרים או שירותים אשר אנו סבורים כי מתאימים לך ואתה מאשר לנו לשלוח לך הודעות
          פרסומיות אודותיהם (ג) בכדי שנוכל לספק לך המלצות ושירות טובים יותר בעתיד באופן מיטבי.
        </p>
        <p>
          למרות האמור לעיל מובהר בזאת כי אלגוריתמים, טכניקות או מוצר מכל סוג הקשורים למערכת שיפותחו
          על בסיס שימוש במידע כאמור יהיו שייכים אך ורק לחברה, ולך לא תהיה כל זכות בהם.
        </p>
        <p>
          בכל מקרה שבו תמסור פרטים באמצעות המערכת, אזי הנך מצהיר ומתחייב כי כל הפרטים והמידע אשר הנך
          מוסר ו/או תמסור נכונים, מלאים ומדויקים והשימוש בהם יעשה בהתאם ובכפוף לתנאי הצהרת הפרטיות.
        </p>
        <p>
          הנך מתחייב כי לא תעביר מידע הנוגע לצד שלישי מכל מין וסוג שהוא בלי הסכמתו. הנך מאשר כי ידוע
          לך כי העברת מידע הנוגע לצד שלישי, ללא הסכמת אותו צד שלישי, מהווה עבירה פלילית, והנך מתחייב
          לשפות ולפצות את החברה בגין כל נזק אובדן או חיוב שיגרם לה עקב שימוש אסור או שלא כדין במידע
          של צד שלישי.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>בעלות וזכות הקניין</h3>
        <p>
          ידוע לך כי כל התכנים המופיעים במערכת ו/או בחומרים שימסרו או יגיעו אליך באמצעות המערכת
          לרבות חומרים, עיצוב טקסט, תוכנה, מוזיקה, וידאו, גרפיקה חומרים המוכלים בפרסומות או בהודעות
          הנשלחות אליך או במידע מסחרי המוצע לך על ידי החברה, הינם קניינה הבלעדי של החברה ו/או צדדים
          שלישיים אחרים ויישארו קניינם הבלעדי בכל עת.
        </p>
        <p>
          כל זכויות הקניין הרוחני (לרבות, בין השאר, זכויות יוצרים, סודות מסחריים, סימני מסחר, פטנטים
          וכיוצא בזה) הקיימים ו/או מגולמים במערכת, ו/או מצורפים, קשורים, ו/או מתייחסים למערכת הינם
          בבעלותה הבלעדית של החברה ויישארו בבעלותה הבלעדית כאמור.
        </p>
        <p>
          אין בתנאים אלו בכדי להעביר אליך כל זכות במערכת או בקשר אליה, ו/או בחומרים שיועברו אליך
          ו/או שיצולמו על ידיך אלא רק זכות מוגבלת להשתמש בהם בהתאם לתנאים אלו ולהוראות הדין. שום דבר
          מהאמור בתנאים אלו אינו מהווה ויתור על זכויות הקניין הרוחני של החברה או צד שלישי כלשהו על
          פי כל דין.
        </p>
        <p>
          כל התכנים הנוגעים לך באופן אישי, לרבות תמונותיך ומידע אישי שתמסור אודותיך או אודות רווק
          (ככל שהנך שדכן), אשר יועברו על ידיך באמצעות המערכת, יהיו שייכים לך או לאותו צד ג', ובעצם
          מסירתם למערכת הנך נותן לחברה זכות שימוש לשמרם ולפרסמם וכן לבצע על בסיסם פילוחים
          וסטטיסטיקות, ולכל שימוש אחר בהתאם למדיניות הפרטיות של המערכת.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>רישיון</h3>
        <p>
          החברה מעניקה לך בזאת, ואתה מקבל, רישיון מוגבל, אישי, שאינו בלעדי, ללא זכות להמחאה,
          בלתי-מסחרי, שאין להעניק על בסיסו רישיונות משנה, ואשר ניתן לביטול באופן מלא, להשתמש במערכת
          על גבי מכשיר שבבעלותך או בשליטתך, כל זאת בהתאם לתנאים ולהוראות הנכללים בתנאים אלו.
        </p>
        <p>החברה שומרת לעצמה את כל הזכויות במערכת אשר לא הוענקו במסגרת תנאים אלו במפורש.</p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>שימושים אסורים</h3>
        <p>
          למעט אם הותר באופן מפורש בתנאים אלו ללא הסכמה מוקדמת בכתב של החברה, הנך מסכים שלא: (i)
          להשתמש, לשנות או לשלב את המערכת לתוך תוכנה אחרת, או ליצור יצירות נגזרות מכל חלק של המערכת;
          ו - (ii) למכור, לתת רישיון (או רישיון משנה), להחכיר, להמחות, להעביר, למשכן או לשתף בזכויות
          שלך על פי תנאים אלו כל אדם אחר; (iii) להעתיק, להפיץ או לשעתק את המערכת לטובת צדדים
          שלישיים; (iv) לגלות (disclose) את התוצאות של ביצועי המערכת, או להשתמש בתוצאות אלה עבור
          פיתוח מערכת מתחרה; ו/או (v) לשנות, לפרק, לעשות פעולות של הידור הפוך, הנדסה הפוכה, עדכון או
          שיפור של המערכת או ניסיון לגלות את קוד המקור של המערכת.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>תחזוקה ותמיכה</h3>
        <p>
          לא חלה על החברה כל חובה על פי תנאים אלו לספק תמיכה, תחזוקה, שדרוגים, שינויים או גרסאות
          חדשות של המערכת. עם זאת, החברה עשויה מפעם לפעם להוציא גרסאות שדרוג של המערכת, ועשויה לשדרג
          באופן אלקטרוני ואוטומטי את גרסת המערכת בה את משתמשת על גבי המכשיר הנייד שלך. אתה נותן את
          הסכמתך לשדרוג אוטומטי שכזה, ומסכים כי תנאים אלו יחולו על כל השדרוגים כאמור.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>הסרת אחריות</h3>
        <p>
          המערכת מסופקת לך "כמות שהיא" ללא כל אחריות מכל סוג שהוא, במפורש או מכללא. החברה אינה
          מבטיחה כי המערכת תענה על דרישותיך או כי פעולת המערכת תתבצע ללא הפרעות או ללא שגיאות. ככל
          שהדבר מותר על פי דין, החברה מחריגה בזאת באופן מפורש כל אחריות מפורשת, לרבות בין היתר,
          אחריות לזכות הקניין או לאי הפרה של זכות קניין, ומכל אחריות מכללא, לרבות בין השאר, אחריות
          מכללא לאיכות מסחרית ולהתאמה למטרה מסוימת. החברה אינה אחראית ואינה ערבה למידת הדיוק,
          השלמות, השימושים או האמינות של התוצאות אשר יושגו באמצעות שימוש במערכת או של כל נתונים או
          מידע אשר יושגו בדרך אחרת באמצעות שימוש במערכת. אתה מאשר כי כל המידע או הנתונים שאתה תוריד
          או תשיג או תקבל באמצעות השימוש במערכת יהיו על סיכונך הבלעדי ועל פי שיקול דעתך בלבד, וכי
          החברה לא תהיה אחראית ולא תישא בכל אחריות לכל נזק אשר ייגרם לך או לרכושך.
        </p>

        <p>
          לחברה לא תהא כל אחריות בגין תוכן או מהות מידע או המלצה אשר ימסר על ידיך או ימסר לך במסגרת
          השימוש במערכת וכל האחריות בגין שימוש או אי שימוש במידע או בהמלצה כאמור תהיה שלך באופן
          בלעדי.
        </p>

        <p>
          החברה פועלת במידת האפשר על מנת שהמידע שיועבר באמצעות המערכת יהיה נכון ומדויק ככל שניתן,
          אולם על אף האמור ייתכן ויחול ליקוי ו/או טעות ו/או אי דיוק במידע ו/או בדרך העברתו, ואתה
          פוטר בזאת את החברה, לרבות נציגיה, עובדיה, מנהליה והפועלים מטעמה, מכל אחריות ו/או חבות ביחס
          לכך.
        </p>

        <p>
          החברה, לרבות נציגיה, עובדיה, מנהליה והפועלים מטעמה, אינם אחראים לזמינות המערכת, השירותים
          והמידע, לרבות לצורה, לשלמות, לעדכניות, לדיוק הנתונים, להתאמתם למשתמש בטיבם, אופיים,
          והיקפם, לליקויים אפשריים, לתוכנו של המידע, לאי התאמת הנתונים שיתקבלו במחשב החברה, לנתונים
          המתקבלים במחשב המשתמש, לאובדן מידע וכיו"ב.
        </p>

        <p>
          החברה, לרבות נציגיה, עובדיה, מנהליה והפועלים מטעמם, לא יהיו אחראים בגין כל נזק, ישיר או
          עקיף, שיגרם לך ו/או לכל צד שלישי בגין השימוש במערכת, לרבות בשירותים, במידע ובתכנים שתקבל
          באמצעותה ו/או הסתמכות עליו ו/או בגין ביטול ו/או הפסקת איזה מהשירותים המוצעים במערכת לרבות
          בגין שיבושים ו/או ליקויים בהעברת המידע בין אם נגרמו במזיד על ידי צד ג' כלשהו ובין אם נגרמו
          בשל תקלה כלשהי.
        </p>

        <p>
          החברה רשאית לכלול במערכת תכנים מסחריים של צדדים שלישיים, לרבות פרסומות, באנרים, מודעות,
          מודעות קופצות וכיו"ב ואתה פוטר בזאת את החברה, לרבות נציגיה, עובדיה, מנהליה והפועלים מטעמה,
          מכל אחריות ו/או חבות הקשורה ו/או המתייחסת לתכנים מסחריים שאינם של החברה עצמה.
        </p>

        <p>
          מובהר לך, כי המידע במערכת עשוי להתעדכן ו/או להשתנות, מעת לעת, וכי תכנים שהופיעו במערכת
          עשויים להימחק ו/או להשתנות ללא הודעה מוקדמת וללא הסכמתך, וכי החברה, לרבות נציגיה, עובדיה,
          מנהליה והפועלים מטעמה, אינם אחראים לכל נזק, מכל מין וסוג, שייגרם במקרה כאמור.
        </p>

        <p>
          החברה אינה מתחייבת, כי השימוש במערכת לא יופרע, יינתן כסדרו בלא הפסקות, יתקיים בבטחה ללא
          טעויות או יהיה חסין מפני נזקים, קלקולים, תקלות או כשלים, והנך פוטר בזאת את החברה, לרבות
          נציגיה, עובדיה, מנהליה והפועלים מטעמה, מכל אחריות ו/או חבות הנוגעת לכך.
        </p>

        <p>
          אם אינך שבע-רצון מחלק כלשהו של המערכת, או מאחד מתנאי השימוש, הסעד היחיד והבלעדי העומד
          לרשותך הוא הפסקת השימוש במערכת והסרתה.
        </p>

        <p>
          החברה שומרת על זכותה לסרב להעניק גישה למערכת או לחלקים ממנה לכל משתמש, לפי שיקול דעתה
          הבלעדי, וללא כל התראה מוקדמת.
        </p>

        <p>
          החברה שומרת על זכותה לגלות בכל עת מידע כפי שיידרש על מנת לקיים את הדרישות החלות במסגרת
          החוק, התקנות, הליכים משפטיים, או בהתאם לדרישת רשות מוסמכת, הכל על פי שיקול דעתה הבלעדי של
          החברה בכל מקרה.
        </p>

        <p>
          החברה רשאית בכל עת, לשיקול דעתה הבלעדי, להפסיק את פעילות המערכת כולה או חלקה, זמנית או
          בצורה קבועה.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>החרגה של נזקים תוצאתיים</h3>
        <p>
          בשום מקרה לא תחול על החברה או מי מטעמה אחריות בגין נזק ישיר, עקיף, דמי נזיקין עונשיים, נזק
          מקרי, מיוחד או תוצאתי, או כל נזק אחר מכל סוג ומין בין לך ובין לכל צד שלישי שהוא, הנובעים
          או קשורים בכל דרך שהיא לתכנים שיועברו באמצעות המערכת, לשימוש בשירותי המערכת לביצועי
          המערכת, לעיכוב בשימוש או לאי-יכולת להשתמש במערכת, לאספקה או לאי-אספקה של שירותים, או לכל
          מידע, תוכנה, מוצר, שירות וגרפיקה נלווית שהושגו באמצעות המערכת, או הנובעים בכל דרך אחרת מן
          השימוש במערכת, לדיוק הנתונים, להתאמתם למשתמש בטיבם, אופיים, והיקפם, לליקויים אפשריים,
          לתוכנו של המידע או לכל מעשה או מחדל אחר של החברה או מי מטעמה בין שהדבר מבוסס על חוזה, ובין
          על דיני נזיקין, אחריות מוחלטת או כל דבר אחר.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>הגבלת אחריות</h3>
        <p>
          במקרה שלמרות הוראות תנאים אלו, ייקבע כי החברה אחראית לנזקים, נזקים אלה לא יעלו על מאה
          שקלים חדשים.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>סיום ההתקשרות</h3>
        <p>
          החברה תהא רשאית להביא לידי סיום את הרישיון אשר ניתן על פי תנאים אלו בכל זמן ומכל סיבה
          שהיא. מבלי לגרוע מהאמור לעיל, הפרה שלך של תנאים אלו תביא את הרישיון שהוענק לך לכדי סיום,
          ואתה, עם סיום הרשיון, תחדל מכל שימוש נוסף במערכת ותמחק או תשמיד כל מידע אשר מסרת או קיבלת
          במסגרת השימוש במערכת.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>דין; סמכות השיפוט</h3>
        <p>
          על תנאים אלו ועל פרשנותם יחולו אך ורק דיני מדינת ישראל. בתי המשפט המוסמכים במחוז תל-אביב
          יהיו בעלי סמכות שיפוט ייחודית בכל סכסוך או מחלוקת שיתגלעו בין הצדדים כתוצאה מתנאים אלו.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>שיפוי</h3>
        <p>
          אתה מסכים להגן, לשפות ולמנוע כל פגיעה של החברה ושל הדירקטורים, נושאי המשרה, ובעלי המניות
          שלה, עובדיה, שליחיה ונציגיה מפני ונגד כל תביעות, הפסדים, עלויות, נזקים, התחייבויות והוצאות
          (לרבות בין השאר, שכר טרחת עורכי דין) אשר נובעים מכל שימוש במערכת על ידיך, תוך הפרה של
          תנאים אלו.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>תוכנה של צדדים שלישיים</h3>
        <p>
          אם המערכת כוללת תוכנה כלשהיא אשר סופקה על ידי צדדים שלישיים, אזי תוכנה זו של צדדים שלישיים
          מסופקת "כמות שהיא" ללא כל אחריות מכל סוג שהוא, והתוכנה האמורה תהיה כפופה לכל ההגבלות
          והתנאים אשר נדרשים על ידי הצד השלישי האמור.
        </p>
        <p>
          אתה מאשר ומסכים כי תנאים אלו נכרתו אך ורק בינך לבין החברה, ולא עם גוגל או אפל, וכי על גוגל
          ו/או אפל לא תחול כל אחריות בקשר עם האפליקציה. השימוש שלך באפליקציה יעשה בהתאם לתנאי השימוש
          של חברת גוגל ו/או אפל ויהיה כפוף להם בנוסף לתנאים אלו. אתה מאשר כי על גוגל ו/או אפל לא חלה
          כל חובה לספק שירותי תחזוקה או תמיכה כלשהם בקשר לאפליקציה. אתה מאשר ומסכים כי גוגל ו/או
          אפל, והחברות המסונפות של גוגל ו/או אפל, הן מוטבים של תנאים אלו לטובת צד שלישי, וכי מעצם
          ההסכמה שלך לתנאים ולהוראות של תנאים אלו, מוקנית לגוגל זכות לאכוף תנאים אלו נגדך, כצד שלישי
          שהוא מוטב של תנאים אלו.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>כללי</h3>
        <p>
          תנאים אלו מוסדרים לפי חוקי מדינת ישראל. הנך מסכים בזה כי בכל מחלוקת הנובעת מהשימוש במערכת
          או הקשורה בה, תחול סמכות השיפוט הבלעדית של בתי המשפט בעיר תל אביב יפו, ושם יהיה מקום
          השיפוט הייחודי. והיה אם ייקבע שחלק כלשהו מתנאים אלו אינו תקף או שאינו ניתן לאכיפה מכח
          הוראות החוקים הרלוונטיים, לרבות אך ללא הגבלה, סעיפי ההתנערות מאחריות והגבלת האחריות
          הנזכרים לעיל, אזי הסעיפים שנשלל תוקפם או שאינם ניתנים לאכיפה ייחשבו כאילו הוחלפו בסעיפים
          תקפים וניתנים לאכיפה שתוכנם תואם במידת הקירוב הגדולה ביותר את כוונת הסעיפים המקוריים,
          ואילו יתר סעיפי תנאים אלו יישארו בתוקפם. ויתר צד אחד, מפורשות או מכללא, על זכות הניתנת לו
          עפ"י מסמך זה במקרה מסוים לא ילמדו ממנו גזירה שווה לכל מקרה אחר ולא יראו בכך ויתור על
          זכויות אותו צד עפ"י תנאים אלו. גרסה מודפסת של תנאים אלו ושל כל הודעה שהועברה במתכונת
          אלקטרונית יהוו ראיה קבילה בהליכים משפטיים או מנהליים המבוססים או הקשורים בהם במידה שווה
          ובאותם תנאים החלים על שאר הרשומות והמסמכים העסקיים שהופקו ונשמרו במקור במתכונת מודפסת. כל
          זכות שאינה ניתנת בתנאי השימוש במפורש, דינה כזכות שמורה. הנך מתחייב לשפות את החברה בגין כל
          נזק הוצאה הפסד או תשלום שייגרמו לה או למי מטעמה או למערכת עקב הפרה על ידך של תנאי השימוש.
        </p>

        <p>
          לכל שאלה או הבהרה נשמח אם תיצור קשר לכתובת הדוא"ל{' '}
          <a href="mailto:yuval@matchers.ai" style={{ color: '#EE2C46', textDecoration: 'none' }}>
            yuval@matchers.ai
          </a>
        </p>

        <h1
          style={{
            textAlign: 'center',
            color: '#EE2C46',
            marginTop: '50px',
            marginBottom: '20px',
            fontSize: '2rem',
          }}
        >
          מדיניות פרטיות
        </h1>

        <p>
          מטרתה של מדיניות הפרטיות הינה להבהיר למשתמש במערכת Matchers, הכוללת אפליקציית מובייל
          ("האפליקציה") וכן כל ממשק אינטרנטי הקשור בה (כולם ביחד יקראו להלן בתנאים אלו "המערכת"),
          בין אם הינו משדך או רווק (כפי הגדרת מונחים אלו בתנאי השימוש), את מדיניות הפרטיות הנהוגה,
          לרבות תיאור אופן השימוש שיעשה על ידי מאצ'אפליי בע"מ ח.פ. 516186699 ("החברה") אשר הינה בעלת
          המערכת, במידע, איסופו ושימושיו. החברה רשאית לערוך או לשנות מעת לעת את מדיניות הפרטיות
          ושימושך במערכת ו\או בשירותים שהיא מציעה, לאחר עדכון ופרסום הצהרת פרטיות מעודכנת מהווה
          הסכמתך לשינוי כאמור.
        </p>

        <p>
          האפליקציה אוספת מידע לגבי כל המשתמש בה מתוך מטרה לשפר את איכות וטיב השירותים שהאפליקציה
          מעניקה.
        </p>
        <p>
          לא קיימת חובה חוקית אשר בגינה עליך למסור את המידע הנאסף על ידי החברה, וכולו נמסר מרצון על
          ידיך על מנת שהחברה תוכל לספק לך שירותים ומוצרים.
        </p>
        <p>
          הנך רשאי לסרב למסור כל או חלק מהמידע המתבקש על ידיך למסור, ואולם, ככל שתסרב למסור את המידע
          המפורט להלן אודותיך, לא תוכל החברה לספק לך שירותים או מוצרים.
        </p>
        <p>
          המידע שתמסור ישמש אך ורק למטרה שלשמה נמסר, ובהתאם למטרות מאגר המידע הרשום של החברה ולא
          לשום מטרה אחרת.
        </p>

        <p>קיימים שני סוגי מידע אשר אנו אוגרים אודותיך:</p>

        <p>
          <strong>מידע כללי</strong> - מידע כללי על המשתמשים במערכת על בסיס מצטבר ואנונימי על מנת
          לשפר ולייעל את איכות וטיב השירותים הניתנים באמצעות המערכת באופן בו לא ניתן לשייך כל מידע
          מזהה ופרטים אישיים כלשהם למידע. מידע כללי יכול שיכלול כדלהלן – נתונים על שימוש בתכונות
          מסוימות, זמני שימוש, מהירות תגובה וכדו׳.
        </p>

        <p>
          <strong>מידע אישי</strong> - מידע הנאסף על ידי המערכת מהמשתמשים – בין אם משדך אשר מכניס את
          פרטיו ופרטי רווקים תחתיו ובין אם רווק העורך את פרטיו, ונאגר במאגרי המידע של החברה שהינו
          בעל אופי אישי, כגון: מספר טלפון, כתובת דואר אלקטרוני, אנשי קשר בטלפון, תכונות מבוקשות בבן
          זוג, מראה חיצוני, העדפה מינית, עמדה פוליטית, וכיו״ב. מידע אישי נאסף רק כאשר המשתמשים
          במערכת בוחרים לספק מידע אישי כאמור מרצונם החופשי לרבות בעת הכנסת פרטים אודותיהם במסגרת
          הרישום למערכת, לרבות בעת הכנסת פרטים אודותיהם על ידי שדכנים, ובעת שהמערכת מייצרת הצעות
          שידוכים ומודדת את תוצאותיה של ההצעה.
        </p>

        <p>
          <strong>מידע בעל רגישות מיוחדת (כהגדרתו בחוק הגנת הפרטיות):</strong>
        </p>
        <p>
          מידע אישי מועבר - מידע אישי שנאסף על ידי המערכת מהמשדכים אודות רווקים במסגרת כרטיסם לרבות
          תחביבים, תמונות, שם, אזור מגורים, מספר טלפון, העדפה מינית, מגדר, תכונות אופי, אורח חיים,
          שנת לידה, גובה, תחום עיסוק, מצב זוגי, תיאור חופשי וכיו"ב וכן מידע אישי שיאסף מהרווקים עצמם
          בעת עריכת המידע אודותיהם. בכל מקרה בו פורסם מידע אישי מועבר הנוגע אל רווק על ידי משדך
          שאינו באישורו של רווק או שאינו מדויק או לחלופין בכל מקרה בו הרווק מעוניין שלא נשתמש במידע
          כאמור, עליו לפנות אלינו ישירות באמצעות מייל yuval@matchers.ai ואנו נדאג למחוק את המידע
          האמור.
        </p>

        <p>
          החברה אוספת ומעבדת מידע אישי למטרות הלגיטימיות והמוגדרות המפורטות להלן, אשר הינך מאשר
          לחברה לבצע שימוש במידע עבורן:
        </p>
        <p>פרטיות אישית: נתונים הקשורים לחיי המשפחה, גובה, מראה חיצוני וכדו׳.</p>
        <p>זהות מינית ודעות: מידע על נטייה מינית, העדפות זוגיות, דעות פוליטיות ואורח חיים.</p>
        <p>פעילות באפליקציה: הצעות שנדחו, והסיבה לדחייה (במידה שסופקה).</p>

        <p>
          באם הנך רווק אזי דע כי מידע אישי שלך יועבר דרך האפליקציה למשדכים אחרים ספציפיים, ובמידה
          והמשדכים ימצאו לנכון - המידע יועבר גם לרווקים אחרים שאותם הם שוקלים לשדך לך, וכן ישמש את
          החברה לשם מציאת התאמות עבורך בעתיד. כמו כן דע כי המשדכים הרלוונטיים שלך עשויים לדעת האם
          אתה ו/או הרווק/ה שהוצעו לך קיבלתם או דחיתם את ההצעה. כמו כן דע כי שני המשדכים וכן הרווק/ה
          השני בהצעת שידוך מסוימת, עשויים לקבל עדכון על כך שהסכמת/דחית/ביטלת את הצעת השידוך, או את
          השידוך הפעיל אם הוא הפך לכזה.
        </p>

        <p>
          באם הנך שדכן אזי דע כי מידע אישי שלך, כגון שם, תמונה, מספר חברים רווקים שאותם אתה מנסה
          לשדך, כמות אנשי קשר משותפים, כמות הצלחות בשידוכים וכיו״ב, ומספר הטלפון (לטובת התכתבות
          ב-WhatsApp) יועבר דרך האפליקציה למשדכים ספציפיים אחרים. כמו כן דע כי הרווקים שאותם תוסיף
          במערכת עשויים לדעת כיצד שמרת את שמם באנשי הקשר שלך.
        </p>

        <p>
          לצורך מתן השירותים במסגרת המערכת, עיבודים סטטיסטיים, פילוחי מידע וכן לצורך קבלת דברי דואר
          בין בדואר רגיל ובין בדואר אלקטרוני ובין בכל דרך אחרת, לרבות הצעות בעלות תוכן שיווקי
          ופרסומי.
        </p>

        <p>
          מתן שירותים, תמיכה וליווי שוטף: כדי לספק לך את השירות באופן רציף וללוות את התקדמות השירות,
          החברה משתמשת במידע מזהה ופרטי קשר רלוונטי.
        </p>

        <p>
          תפעול, אבטחה ושיפור האתר והשירותים: אנו משתמשים במידע טכני למטרות תפעול שוטף, אבטחה ושיפור
          חוויית המשתמש.
        </p>

        <p>
          שליחת דיוור ישיר ותכנים שיווקיים: אנו עשויים להשתמש במידע מזהה ופרטי קשר כדי לשלוח לכם
          עדכונים והצעות שיווקיות. פעולה זו תתבצע אך ורק בכפוף לקבלת הסכמתכם הנפרדת והמפורשת לכך,
          הניתנת לביטול בכל עת. אם אינך מעוניין בדיוור כאמור, זכותך להודיע לנו כי אינך מעוניין
          באמצעות המייל yuval@matchers.ai.
        </p>

        <p>כל מידע אשר תמסור לחברה באמצעות המערכת, הינו וישאר בכל עת מידע אשר בבעלותך המלאה.</p>

        <p>
          החברה רשאית לשמור מידע שיאסוף אודותיך במאגריה, ולעשות בו שימוש, בכפוף לתנאי השימוש,
          מדיניות הפרטיות ועל פי הוראות כל דין.
        </p>

        <p>
          החברה מוודאת כי כל צד שלישי המקבל גישה למידע אישי יהיה כפוף להתחייבויות חוזיות לשמירה על
          סודיות ואבטחת המידע, בהתאם לדרישות דיני הגנת הפרטיות.
        </p>

        <p>
          לשם פעילותה השוטפת של המערכת, לרבות לצורך איסופו של מידע, אימות פרטים, והתאמות האפליקציה
          להעדפותיך, המערכת עושה ו/או תעשה שימוש ב"עוגיות" (Cookies). עוגיות הן קבצי טקסט, אשר
          הדפדפן של המשתמש יוצר לפי פקודה ממחשבי החברה. חלק מהעוגיות יפקעו כאשר תסגור את הדפדפן
          ואחרות נשמרות על גבי הכונן הקשיח במחשב שלך. העוגיות מכילות מידע מגוון כדוגמת הדפים שבהם
          ביקרת, משך הזמן ששהית במערכת, מהיכן הגעת אל המערכת, מדורים ומידע שהמשתמש מבקש לראות בעת
          הכניסה למערכת הרגלי הגלישה שלך, וכיוב. אם הנך מעוניין להימנע מהכנסת "עוגיה" מעין זו
          מהמערכת, עליך לשנות את ההגדרות במערכת ההפעלה ואו בדפדפן בו הנך עושה שימוש. יתר על כן תוכל
          למחוק קבצים אלו שהושתלו במחשבך בכל עת.
        </p>

        <p>
          המערכת מסתמכת על מידע המגיע מצדדים שלישיים, הן מרווקים הן ממשדכנים אשר אינם הרווקים עצמם.
          הנך מודע לכך כי החברה אינה מתחייבת, כי המידע הינו אמין ומדוייק ולא בדקה את אמינות המידע
          המגיע מאותם שדכנים או רווקים. החברה לא תהיה אחראית לכל נזק, אובדן או חיוב מכל מין וסוג
          שהוא שייגרם לך כתוצאה מהסתמכות על מידע זה.
        </p>

        <p>
          החברה נוקטת באמצעי זהירות התואמים את הסטנדרטים הנהוגים בתחום על מנת לשמור, ככל האפשר, על
          סודיות מידע המתקבל על ידיך, ואולם, למרות האמור לעיל, קיים סיכון של חדירה למאגרי הנתונים של
          המערכת, וכן לתעבורת הנתונים בין מכשירך למחשבי המערכת. לפיכך, הנך מאשר כי החברה לא תהיה
          אחראית לכל אובדן נזק או תשלום שיגרם לך (אם יגרם) כתוצאה מחדירה למאגר הנתונים במערכת ו\או
          העברת מידע אודותיך או מידע שנמסר על ידך לצד ג' כלשהו, וזאת ככל שנקטו בצעדים סבירים
          ומקובלים למניעת פעולות שכאלה.
        </p>

        <p>
          החברה לא תמכור או תעביר לאחרים מידע אישי שיתקבל אודותיך, ללא הסכמתך המוקדמת, למעט במקרים
          הבאים, אך ורק במידה הנדרשת לצורך מימוש המטרות המפורטות לעיל: (א) חלה חובה על מסירת המידע
          בהתאם להוראות הדין או החלטה שיפוטית; (ב) ישנו סכסוך בינך ובין החברה בקשר עם המידע האמור;
          (ג) כאשר השימוש במערכת נעשה בניגוד לאמור בתנאי השימוש, בהצהרת הפרטיות ו/או בניגוד להוראות
          כל דין; (ד) מועבר מידע שאינו מזהה אותך באופן אישי, שעיקרו הרגלי גלישה ומידע סטטיסטי (ה)
          המידע מועבר לספקי השירותים או עובדיה של החברה לצורך מתן השירותים במסגרת המערכת לרבות ספקי
          שירותי ענן ואחסון, ספקי שירותים תפעוליים כגון מערכות CRM שירותי תמיכה וכן שליחת הודעות;
          (ו) לצורך שידוך ספציפי שהמערכת ו/או השדכנים מעוניינים לבחון (ז) על פי הוראה של רשויות
          אכיפה וגופים ממשלתיים, ככל שנידרש לכך על פי דין או צו שיפוטי.
        </p>

        <p>
          החברה לא תיחשב כמפרת התחייבות לפרטיות או פוגעת בפרטיות משתמש בשל כל מידע, כהגדרתו בחוק
          המחשבים תשנ"ה-1995, שיהיה בו כדי לזהות משתמש או להתחקות אחריו על ידי אחר, שנובע מהשימוש
          באמצעי תקשורת אלקטרוניים ככלל ותקשורת מחשבים בפרט.
        </p>

        <h3 style={{ color: '#EE2C46', marginTop: '30px' }}>6. זכויות נושאי המידע</h3>
        <p>בכפוף להוראות דיני הפרטיות, עומדות לך כמשתמש הזכויות הבאות ביחס למידע האישי שלך:</p>
        <p>
          <strong>זכות עיון:</strong> הזכות לעיין בכל המידע האישי אודותיך אשר בידי החברה וכן לקבל
          אישור האם מידע אישי אודותיך מעובד על ידינו, ולקבל גישה למידע זה ופרטים נוספים אודות
          העיבוד.
        </p>
        <p>
          <strong>זכות לתיקון:</strong> הזכות לדרוש את תיקונו או השלמתו של מידע אישי אשר בידי החברה
          שאינו נכון, שלם או מדויק.
        </p>
        <p>
          <strong>זכות למחיקה:</strong> הזכות לבקש את מחיקתו של חלק מהמידע אישי אודותיך השמור אצלנו,
          בכל עת, וללא צורך בסיבה, בכפוף למגבלות הקבועות בדין (למשל, חובת שמירת תיעוד רפואי לתקופה
          הנדרשת).
        </p>
        <p>
          <strong>זכות להישכח:</strong> הזכות לבקש את מחיקתו של כלל המידע אישי אשר אנו מחזיקים
          אודותיך, בכפוף למגבלות הקבועות בדין (למשל, חובת שמירת תיעוד רפואי לתקופה הנדרשת). דע כי
          מחיקה כאמור יתכן ותפגע בשירותים עתידיים שתקבל באמצעות המערכת.
        </p>
        <p>
          <strong>זכות להגבלת עיבוד:</strong> הזכות לבקש את הגבלת עיבוד המידע האישי אודותיך על פי
          הגדרות הדין החל
        </p>
        <p>
          <strong>הזכות לחזור בך מהסכמתך:</strong> ככל שעיבוד המידע האישי מבוסס על הסכמתך, הינך רשאי
          לחזור בך מהסכמתך בכל עת. חזרה מהסכמה לא תשפיע על חוקיות העיבוד שבוצע לפני כן.
        </p>

        <p>
          לצורך מימוש זכויותיך, יש לפנות בכתב לממונה על הגנת הפרטיות בכתובת הדוא"ל המצוינת לעיל.
          החברה תשיב לבקשתך בתוך פרק הזמן הקבוע בדין.
        </p>

        <p>
          המידע האישי יישמר למשך התקופה הדרושה למימוש המטרות שלשמן נאסף, או לתקופה ארוכה יותר ככל
          שנדרש על פי דין. מידע שאינו נחוץ עוד יימחק באופן מאובטח.
        </p>

        <p>
          לכל שאלה או הבהרה נשמח אם תיצור קשר עם הממונה על הגנת הפרטיות מר יובל פרקש בכתובת המייל{' '}
          <a href="mailto:yuval@matchers.ai" style={{ color: '#EE2C46', textDecoration: 'none' }}>
            yuval@matchers.ai
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
